import React from 'react';
import logo from '../assets/images/Logo.png';
import '../styles/AboutUs.css'; // New CSS file

const AboutUs = () => (
  <div className="aboutus-container">
    <div className="aboutus-header">
      <div className="aboutus-logo-col">
        <img src={logo} alt="AstroShubh Logo" className="aboutus-logo" />
      </div>
      <div className="aboutus-text-col">
        <h1>About Us</h1>
        <p>
          Welcome to <strong>AstroShubh</strong>! We are a team of professional astrologers
          dedicated to providing unique and insightful solutions to your questions. Our consultants
          use ancient Vedic principles combined with modern expertise to guide you through life's challenges.
        </p>
      </div>
    </div>

    <div className="aboutus-content">
      <p>
        At AstroShubh, we believe that every question deserves a thoughtful and personalized answer.
        Our astrologers combine years of experience with a passion for helping people find clarity
        and peace. Whether you are facing challenges in your career, relationships, or personal
        growth, our team is here to guide you with wisdom and compassion.
      </p>
      <ul>
        <li>Personalized astrology reports delivered instantly via WhatsApp.</li>
        <li>Expert guidance for career, relationships, health, and more.</li>
        <li>Confidential consultations with trusted professionals.</li>
        <li>Solutions tailored to your unique birth details and questions.</li>
        <li>Over 4,500 satisfied users and growing!</li>
      </ul>
      <p>
        We use a blend of traditional Vedic astrology and modern techniques to analyze your birth
        details and provide solutions that are truly unique to you. Our commitment is to deliver
        accurate, confidential, and timely advice—empowering you to make informed decisions and
        lead a happier life.
      </p>
      <p>
        Join thousands of satisfied users who have found answers and direction through AstroShubh.
        Ask your question today and experience the difference of professional astrology guidance.
      </p>
    </div>
  </div>
);

export default AboutUs;
